import { DateRangePickerViews, type IDateRange } from "../types";

const genetiveStart = {
  [DateRangePickerViews.DAY]: "du",
  [DateRangePickerViews.MONTH]: "de",
  [DateRangePickerViews.YEAR]: "de",
} as const;

const genetiveEnd = {
  [DateRangePickerViews.DAY]: "au",
  [DateRangePickerViews.MONTH]: "à",
  [DateRangePickerViews.YEAR]: "à",
} as const;

export const formatRange = (range: IDateRange, selectedView: DateRangePickerViews, timeZone: string) => {
  let formattedStart: string | null = null;
  let formattedEnd: string | null = null;

  switch (selectedView) {
    case DateRangePickerViews.DAY: {
      formattedStart =
        range.startDate?.toLocaleString("fr-FR", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
          timeZone,
        }) ?? null;
      formattedEnd =
        range.endDate?.toLocaleString("fr-FR", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
          timeZone,
        }) ?? null;
      break;
    }
    case DateRangePickerViews.MONTH: {
      formattedStart =
        range.startDate?.toLocaleString("fr-FR", {
          month: "2-digit",
          year: "numeric",
          timeZone,
        }) ?? null;
      formattedEnd =
        range.endDate?.toLocaleString("fr-FR", {
          month: "2-digit",
          year: "numeric",
          timeZone,
        }) ?? null;
      break;
    }
    case DateRangePickerViews.YEAR: {
      formattedStart =
        range.startDate?.toLocaleString("fr-FR", {
          year: "numeric",
          timeZone,
        }) ?? null;
      formattedEnd =
        range.endDate?.toLocaleString("fr-FR", {
          year: "numeric",
          timeZone,
        }) ?? null;
      break;
    }
  }

  if (formattedStart && formattedEnd) {
    return `${formattedStart} - ${formattedEnd}`;
  }

  if (formattedStart) {
    return `À partir ${genetiveStart[selectedView]} ${formattedStart}`;
  }

  if (formattedEnd) {
    return `Jusqu'${genetiveEnd[selectedView]} ${formattedEnd}`;
  }

  return "";
};
